
import { useEffect, useState } from 'react'
import CtaButton from '../../components/ctaButton/CtaButton'
import './style.scss'
import { useAppSelector } from '../../redux/hooks'
import { UserData } from '../../server/types'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { adminStateData } from '../../data/adminStateData'
import { AccountStatus } from '../../types/types'

function AdminContentArea() {
	const [customers, setCustomers] = useState<UserData[]>([])
	const [instructors, setInstructors] = useState<UserData[]>([])
	const [interactions, setInteractions] = useState<UserData[]>([])
	const [supportTickets, setSupportTickets] = useState<UserData[]>([])
	const [adminDataLoaded, setAdminDataLoaded] = useState<boolean>(false)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	// Setup test values
	useEffect(() => {
		// setTimeout(() => loadProfileData(), 200)
		if (dataLoadRequestFinished === true) {
			setAdminDataLoaded(true)
			setCustomers(adminStateData.getFlaggedCustomers())
			setInstructors(adminStateData.getInstructorsWithStatus(AccountStatus.CERTIFICATE_UNDER_REVIEW))
		}
	}, [dataLoadRequestFinished])

	return (
		<div className='dashboard-content-area-wrap'>
			{adminDataLoaded &&
				<>
				<div className='dashboard-content-area-half-card-wrap'>
					<div className='dashboard-content-area-card'>
						<div className='dashboard-content-area-card-title-wrap'>
							<img
								className='dashboard-content-area-card-title-icon'
								src={`/imgs/icons/dashboard/icon-dashboard-customers.svg`}
								alt='Customer symbol'
							/>
							<div className='dashboard-content-area-card-title-label'>Customer Management</div>
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{
							// chats.length === 0 ?
							customers.length === 0 ?
								<span>No Flagged Customers</span>
								:
								// chats.map((chat: DashboardChat, index: number) => 
								customers.map((customer: UserData, index: number) => 
									<a 
										className='dashboard-content-area-card-chat-wrap'
										key={`customerItem${index}`}
										href={`${PAGE_URLS.ADMIN_CUSTOMER}?id=${customer.id}`}
									>
										<img
											className='dashboard-content-area-card-chat-img'
											alt='profile thumbnail'
											src={customer?.profile_pics ? getProfilePicPath(customer?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-content-area-card-chat-details-wrap'>
											<div className='dashboard-content-area-card-chat-name'>{customer?.name}</div>
											<div className='dashboard-content-area-card-chat-extract'>{customer?.email}</div>
										</div>
										<div className='dashboard-admin-status dashboard-admin-status-flagged'>Flagged</div>
									</a>
								)
							}
						</div>
						<div
							className='dashboard-content-area-card-bottom-wrap'
						>
							<CtaButton
								label='View All'
								size='large'
								onClick={() => window.location.replace(PAGE_URLS.ADMIN_ALL_CUSTOMERS)}
							/>
						</div>
					</div>
					<div className='dashboard-content-area-card'>
						<div className='dashboard-content-area-card-title-wrap'>
							<img
								className='dashboard-content-area-card-title-icon'
								src={`/imgs/icons/dashboard/icon-dashboard-instructors.svg`}
								alt='Instructor symbol'
							/>
							<div className='dashboard-content-area-card-title-label'>Instructor Management</div>
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{
							// chats.length === 0 ?
							instructors.length === 0 ?
								<span>No Flagged Instructors</span>
								:
								// chats.map((chat: DashboardChat, index: number) => 
								instructors.map((instructor: UserData, index: number) => 
									<a 
										className='dashboard-content-area-card-chat-wrap'
										key={`instrouctorItem${index}`}
										href={`${PAGE_URLS.ADMIN_INSTRUCTOR}?id=${instructor.id}`}
									>
										<img
											className='dashboard-content-area-card-chat-img'
											alt='profile thumbnail'
											src={instructor?.profile_pics ? getProfilePicPath(instructor?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-content-area-card-chat-details-wrap'>
											<div className='dashboard-content-area-card-chat-name'>{instructor?.name}</div>
											<div className='dashboard-content-area-card-chat-extract'>{instructor?.email}</div>
										</div>
										<div className='dashboard-admin-status dashboard-admin-status-doc-review'>Doc Review</div>
									</a>
								)
							}
						</div>
						<div
							className='dashboard-content-area-card-bottom-wrap'
						>
							<CtaButton
								label='View All'
								size='large'
								onClick={() => window.location.replace(PAGE_URLS.ADMIN_ALL_INSTRUCTOR)}
							/>
						</div>
					</div>
				</div>
				<div className='dashboard-content-area-half-card-wrap'>
					<div className='dashboard-content-area-card'>
						<div className='dashboard-content-area-card-title-wrap'>
							<img
								className='dashboard-content-area-card-title-icon'
								src={`/imgs/icons/dashboard/icon-dashboard-chat.svg`}
								alt='Customer symbol'
							/>
							<div className='dashboard-content-area-card-title-label'>Chats Management</div>
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{
							// chats.length === 0 ?
							interactions.length === 0 ?
								<span>No Flagged Chats</span>
								:
								// chats.map((chat: DashboardChat, index: number) => 
								interactions.map((customer: UserData, index: number) => 
									<a 
										className='dashboard-content-area-card-chat-wrap'
										key={`customerItem${index}`}
										href={`${PAGE_URLS.ADMIN_CUSTOMER}?id=${customer.id}`}
									>
										<img
											className='dashboard-content-area-card-chat-img'
											alt='profile thumbnail'
											src={customer?.profile_pics ? getProfilePicPath(customer?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-content-area-card-chat-details-wrap'>
											<div className='dashboard-content-area-card-chat-name'>{customer?.name}</div>
											<div className='dashboard-content-area-card-chat-extract'>{customer?.email}</div>
										</div>
										<div className='dashboard-admin-status dashboard-admin-status-flagged'>Flagged</div>
									</a>
								)
							}
						</div>
						<div
							className='dashboard-content-area-card-bottom-wrap'
						>
							<CtaButton
								label='View All'
								size='large'
								onClick={() => console.log('View All Customers clicked')}
							/>
						</div>
					</div>
					<div className='dashboard-content-area-card'>
						<div className='dashboard-content-area-card-title-wrap'>
							<img
								className='dashboard-content-area-card-title-icon'
								src={`/imgs/icons/dashboard/icon-dashboard-support.svg`}
								alt='Instructor symbol'
							/>
							<div className='dashboard-content-area-card-title-label'>Support Management</div>
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{
							// chats.length === 0 ?
							supportTickets.length === 0 ?
								<span>No Active Support Tickets</span>
								:
								// chats.map((chat: DashboardChat, index: number) => 
								supportTickets.map((instructor: UserData, index: number) => 
									<a 
										className='dashboard-content-area-card-chat-wrap'
										key={`instrouctorItem${index}`}
										href={`${PAGE_URLS.ADMIN_INSTRUCTOR}?id=${instructor.id}`}
									>
										<img
											className='dashboard-content-area-card-chat-img'
											alt='profile thumbnail'
											src={instructor?.profile_pics ? getProfilePicPath(instructor?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-content-area-card-chat-details-wrap'>
											<div className='dashboard-content-area-card-chat-name'>{instructor?.name}</div>
											<div className='dashboard-content-area-card-chat-extract'>{instructor?.email}</div>
										</div>
									</a>
								)
							}
						</div>
						<div
							className='dashboard-content-area-card-bottom-wrap'
						>
							<CtaButton
								label='View All'
								size='large'
								onClick={() => console.log('View All Instructors clicked')}
							/>
						</div>
					</div>
				</div>
				</>
			}
		</div>
	)
}

export default AdminContentArea
